import { useEffect, useState,lazy } from 'react'
import Banner from '../Components/banner/Banner';
import BreadcrumbsComponent from '../Components/common/BreadcrumbsComponent';
import { useParams } from 'react-router';
import BannerData from '../models/BannersData';
import Hashids from 'hashids';
import LoyaltyCardContent from '../Components/contents/LoyaltyCardContent';
import TitleComponent from '../Components/common/TitleComponent';
import { LoyaltyCardsData } from '../models/LoyaltyCardsData';
import ImageFigureContent from '../Components/common/ImageFigureContent';
import YakkalaFrontImage from '../assets/images/LoyaltyCards/Golden-lotus-front.jpg';
import ColomboFrontImage from '../assets/images/LoyaltyCards/Golden-lotus-front-colombo.jpg';
import BackImage from '../assets/images/LoyaltyCards/lotus card back.jpeg';
import LanguageSelect from '../Components/select/LanguageSelect';
import GridPoints from '../Components/grid/GridPoints';

const LoyaltyCardDetailsPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { LoyaltyCardId } = useParams();

    const hashids = new Hashids('wellness', 6);
    // const encryptedLCId = hashids.encode(LoyaltyCardId)
    const decryptedLCId = hashids.decode(LoyaltyCardId);

    const loyaltyCardData = LoyaltyCardsData.find((CardData) => CardData.id == decryptedLCId);

    const [language, setLanguage] = useState("english");

    const BreadCrumbsPath = [
        {
            id: 1,
            pathName: "Loyalty Cards",
            pathLink: "",
        },
        {
            id: 2,
            pathName: loyaltyCardData.cardName,
            pathLink: "",
        },
    ];

    return (
        <>
            {
                decryptedLCId == 2 ? (
                    <>
                        <div className='mt-12'>
                            <TitleComponent Title={loyaltyCardData.cardName} Subtitle="Collect 9 stamps with each qualifying treatment, enjoy exclusive discounts, and get 22,750LKR OFF on your 10th visit." />
                        </div>
                        <div className='w-full md:flex justify-center p-2 gap-4'>
                            <div className='md:w-[30%] m-5 rounded-xl shadow-md transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-2xl'>
                                <ImageFigureContent image={YakkalaFrontImage} />
                            </div>
                            <div className='md:w-[30%] m-5 rounded-xl shadow-md transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-2xl'>
                                <ImageFigureContent image={ColomboFrontImage} />
                            </div>
                            <div className='md:w-[30%] m-5 rounded-xl shadow-md transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-2xl'>
                                <ImageFigureContent image={BackImage} />
                            </div>
                        </div>

                        <div className='w-full md:flex justify-center p-2 gap-4'>

                            <div className='w-full md:flex justify-center p-2 gap-4'>

                                <div className='w-full px-10 rounded-xl shadow-md hover:shadow-2xl'>
                                    <div className='mt-5 mb-3 gap-2 items-center justify-center'>

                                        <h3 className="font-semibold text-center leading-snug tracking-normal text-slate-800 mx-auto lg:mx-24 text-md md:text-lg lg:text-3xl w-full max-w-lg lg:max-w-full">
                                            {loyaltyCardData.cardName} Loyalty Card Terms & Conditions
                                        </h3>

                                        <div className='w-full flex justify-end'>
                                            <LanguageSelect language={language} setLanguage={setLanguage} />
                                        </div>
                                    </div>

                                    <div className='w-full mb-6'>
                                        <GridPoints gridDataArray={loyaltyCardData.inclusions[language]} />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </>
                ) : (
                    <>
                        {BannerData.filter((item) => item.title === "Loyalty Card").map((item) => (
                            <Banner key={item.id} bannerDetails={item} Category={loyaltyCardData.cardName} />
                        ))}

                        <BreadcrumbsComponent fullWidth BreadCrumbsPath={BreadCrumbsPath} />

                        <TitleComponent Title={loyaltyCardData.cardName} Subtitle="Collect 9 stamps with each qualifying treatment, enjoy exclusive discounts, and get 22,750LKR OFF on your 10th visit." />

                        <LoyaltyCardContent loyaltyCardData={loyaltyCardData} />
                    </>
                )
            }
        </>
    )
}

export default LoyaltyCardDetailsPage